"use client"

import { useBandHudOverlay } from "./BandHudOverlayChannel"

// In-flow layer that paints ONLY the hovered-band highlight image (the
// darker/saturated raster). It renders as a sibling pinned to the graph's box,
// but at a z-index BELOW the globe — so the globe paints on top of the band
// highlight. The small text annotations that must stay readable over the globe
// (the danger label + the point hover tooltip) live in AboveGlobeBandHudOverlay
// instead.
//
// The payload carries graph-local coordinates (origin = graph container's
// top-left, which is this layer's own origin), so it maps straight to
// left/top with no getBoundingClientRect.
export const BelowGlobeBandHudOverlay = () => {
  const { highlight } = useBandHudOverlay()

  if (!highlight) return null

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      alt=""
      aria-hidden="true"
      src={highlight.imageHref}
      style={{
        position: "absolute",
        left: highlight.left,
        top: highlight.top,
        width: highlight.width,
        height: highlight.height,
        // Tailwind Preflight applies `img { max-width: 100% }` globally,
        // which would otherwise clamp this image to its (graph-width)
        // container and horizontally squish the highlight off the band.
        // The raster width intentionally overhangs the graph, so opt out.
        maxWidth: "none",
        opacity: highlight.opacity,
        transition: highlight.fadeInMs
          ? `opacity ${highlight.fadeInMs}ms ease`
          : undefined,
        filter: highlight.featherBlurPx
          ? `blur(${highlight.featherBlurPx}px)`
          : undefined,
        pointerEvents: "none",
      }}
    />
  )
}
